/**
 * AuditoriaTemplate — página CRUD de Auditoria.
 *
 * Exibe todos os registros de auditoria do sistema em um EntityGrid completo.
 * Campos: tipo (com template de cor/ícone), usuário responsável, modelo da
 * entidade, id do registro auditado e data de criação.
 *
 * Ações futuras (esqueleto): Restaurar e Parâmetros.
 */
import React, { Component } from 'react';
import { Tag } from 'primereact/tag';

import { EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { AuditoriaParametrosDialog, confirmarRestauro } from 'hay-core-react';
import { Auditoria } from 'hay-core-react';
import { AuditoriaTipo } from 'hay-core-react';
import { Usuario } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
// ── Mapeamento tipo → Tag ─────────────────────────────────────────────────────

const TIPO_CONFIG = {
    'main.auditoria.tipo.criacao':  { severity: 'success', icon: 'pi-plus-circle' },
    'main.auditoria.tipo.edicao':   { severity: 'warning', icon: 'pi-pen-to-square' },
    'main.auditoria.tipo.exclusao': { severity: 'danger',  icon: 'pi-trash' },
};

// ── Model ─────────────────────────────────────────────────────────────────────

const model = {
    tipo: {
        exibir:   'main.auditoria.tipo',
        visivel:  true,
        tipo:     'enum',
        entidade: 'auditoria.tipo.entidade',
        template: 'tipo.template',
         fixar: true,
        largura: "10rem"
    },
    usuario: {
        exibir:       'main.auditoria.usuario',
        visivel:      true,
        tipo:         'relacao',
        entidade:     'usuario.entidade',
        camporelacao: 'nome',
        template:     'usuario.template',
    },
    modelo: {
        exibir:  'main.auditoria.modelo',
        visivel: true,
    },
    regsId: {
        exibir:  'main.auditoria.regsId',
        visivel: true,
    },
    pai: {
        exibir:   'main.auditoria.pai',
        hidegrid: true,
    },
    createdAt: {
        exibir:   'main.createdAt',
        visivel:  true,
        tipo:     'date',
        time:     true,
        largura:  '10rem',
    },
};

// ── Renderers ─────────────────────────────────────────────────────────────────
// lodash.get(renderers, path) — caminhos pontilhados requerem objetos aninhados

const renderers = {
    auditoria: {
        tipo: { entidade: AuditoriaTipo },
    },
    tipo: {
        template: (rowData) => {
            const cfg = TIPO_CONFIG[rowData.tipo] || { severity: 'info', icon: 'pi-circle' };
            return (
                <Tag
                    severity={cfg.severity}
                    icon={`pi ${cfg.icon}`}
                    value={UtilService.traduzir(rowData.tipo)}
                    className="white-space-nowrap"
                />
            );
        },
    },
    usuario: {
        entidade: Usuario,
        template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '-',
    },
};

// ── Formulário de visualização ────────────────────────────────────────────────

class AuditoriaFormulario extends Component {
    render() {
        const { model: m, contexto } = this.props;
        return (
            <>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={m.tipo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={m.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={m.modelo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={m.regsId} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={m.pai} contexto={contexto} />
                </div>
            </>
        );
    }
}

// ── Template (componente exportado) ──────────────────────────────────────────

class AuditoriaTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            parametrosVisivel: false,
            parametrosRow:     null,
        };
    }

    processos() {
        return [
            {
                label:    'main.auditoria.restaurar',
                icon:     'pi pi-history',
                disabled: true,
                ativo:    (p, selected) => {
                    p.disabled = selected.length !== 1 || selected[0]?.tipo !== 'main.auditoria.tipo.edicao';
                    return p;
                },
                command: () => {
                    const row = this.gridRef?.getSelected()?.[0];
                    if (row) confirmarRestauro(row, () => this.gridRef?.atualizar());
                },
            },
            {
                label:    'main.auditoria.parametros',
                icon:     'pi pi-list',
                disabled: true,
                ativo:    (p, selected) => { p.disabled = selected.length !== 1; return p; },
                command:  () => {
                    const row = this.gridRef?.getSelected()?.[0];
                    if (row) this.setState({ parametrosVisivel: true, parametrosRow: row });
                },
            },
        ];
    }

    render() {
        const { parametrosVisivel, parametrosRow } = this.state;
        return (
            <>
                <EntityGrid
                    ref={(ref) => this.gridRef = ref}
                    entidade={Auditoria}
                    model={model}
                    identidade="main.auditoria"
                    icone="pi-hammer"
                    storageKey="dt-auditoria"
                    renderers={renderers}
                    processos={this.processos()}
                    permissoes={this.props.permissoes}
                    configuracao={this.props.configuracao}
                    navigate={this.props.navigate}
                    location={this.props.location}
                    searchparams={this.props.searchparams}
                    formulario={(m, ctx) => <AuditoriaFormulario model={m} contexto={ctx} />}
                />
                <AuditoriaParametrosDialog
                    visible={parametrosVisivel}
                    onHide={() => this.setState({ parametrosVisivel: false })}
                    tipo={parametrosRow?.tipo}
                    parametros={parametrosRow?.parametros}
                    parametrosOld={parametrosRow?.parametrosOld}
                    modelo={parametrosRow?.modelo}
                    regsId={parametrosRow?.regsId}
                    traduzir={(chave) => UtilService.traduzir(chave)}
                />
            </>
        );
    }
}

export default AuditoriaTemplate;
